import { render } from "./DeviceComponent.vue?vue&type=template&id=0e2977f5&scoped=true"
import script from "./DeviceComponent.vue?vue&type=script&lang=js"
export * from "./DeviceComponent.vue?vue&type=script&lang=js"

import "./DeviceComponent.vue?vue&type=style&index=0&id=0e2977f5&scoped=true&lang=css"

import exportComponent from "/Users/dmitriy-pc/Projects/ds-admin/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0e2977f5"]])

export default __exports__